<template>
  <div class="c-test-card">
    <main>
      <header>
        <span class="badge">{{isQuestion ? '错题导出练习' : '知识点巩固练习'}}</span>
        {{data.exercise_name}}
      </header>
      <footer class="mt-30">
        {{data.test_name === '' ? '日常练习' : `测评课程：${data.test_name}`}}
        <span v-if="!isQuestion">总知识点数：{{data.tag_code_number}}个</span>
        <span>总练习题目数：{{data.question_number}}个</span>
        <span>布置时间：{{data.created_at}}</span>
      </footer>
    </main>
    <div class="button-container">
      <el-popover
        placement="bottom"
        width="120"
        popper-class="s-popper"
      >
        <div>
          <button @click="onCopyClick(data)">题目链接</button>
          <button @click="onCopyClick(data, 1)">题目+答案链接</button>
        </div>
        <button class="s-button" slot="reference">复制链接</button>
      </el-popover>
      <el-popover
        placement="bottom"
        width="120"
        popper-class="s-popper"
      >
        <div>
          <button @click="onOpenClick(data)">题目链接</button>
          <button @click="onOpenClick(data, 1)">题目+答案链接</button>
        </div>
        <button class="s-button ml-30 is-orange" slot="reference">打 开</button>
      </el-popover>
    </div>
    <input type="text" readonly :value="link" ref="input">
  </div>
</template>

<script>
import { openTab } from '@/utils';

const QUESTION = [2, 4];
export default {
  name: 'TestCard',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      link: '',
    };
  },
  computed: {
    // 是否知识点
    isQuestion() {
      return QUESTION.find((item) => item === this.data.type);
      // return this.data.type === QUESTION;
    },
  },
  methods: {
    copy(text) {
      try {
        const input = document.createElement('input');
        input.value = text;
        document.body.appendChild(input);
        input.select();
        input.setSelectionRange(0, input.value.length);
        document.execCommand('Copy');
        document.body.removeChild(input);
        this.$message({
          message: '复制成功',
          type: 'success',
        });
      } catch (e) {
        console.log(e);
        console.error('复制失败，请重试~');
        this.$message({
          message: '复制失败，尝试点击“打开”后复制',
          type: 'warning',
        });
      }
    },
    onCopyClick(data, showAnswer = 0) {
      // '/pt/export-test'
      this.copy(`${window.location.protocol}//${window.location.host}/pt/export-test?serialNum=${data.serial_num}&teacherId=${data.teacher_id}&showAnswer=${showAnswer}`);
    },
    onOpenClick(data, showAnswer = 0) {
      openTab(`${window.location.protocol}//${window.location.host}/pt/export-test?serialNum=${data.serial_num}&teacherId=${data.teacher_id}&showAnswer=${showAnswer}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.c-test-card {
  width: 100%;
  background-image: url('~@/views/pt/images/bg_panel.png');
  background-size: 100% 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 50px 25px 25px;
  & +.c-test-card {
    margin-top: 10px;
  }
  input {
    width: 1px;
    height: 1px;
    background: transparent;
    color: transparent;
    border: 0;
    outline: 0;
    user-select: none;
    position: absolute;
  }
  header {
    color: rgba(17, 31, 44, 1);
    font-size: 17px;
    font-weight: 500;
    display: flex;
    align-items: center;
  }
  footer {
    color: rgba(17, 31, 44, 0.8);
    font-size: 14px;
    span {
      padding-left: 24px;
    }
  }
  .badge {
    width: 110px;
    height: 24px;
    background: #F0F2F5;
    border-radius: 3px;
    border: 1px solid #D7DFEC;
    color: rgba(90, 94, 102, 1);
    font-size: 13px;
    margin-right: 10px;
    text-align: center;
    line-height: 24px;
  }
  .s-button {
    width: 100px;
    height: 36px;
    background: #1989FA;
    border-radius: 4px;
    font-size: 15px;
    color: #fff;
    &.is-orange {
      background: #FFA82D;
    }
  }
}
</style>
<style lang="scss">
.el-popover.s-popper {
  padding: 0;
  button {
    color: rgba(90, 94, 102, 1);
    font-size: 14px;
    text-align: center;
    width: 100%;
    padding: 10px;
    &:hover {
      background: rgba($color: #1989FA, $alpha: 0.1);
    }
  }
}
</style>
